<template>
  <van-swipe
    class="inner-swiper"
    ref="inner-swiper1"
    :show-indicators="true"
    :initial-swipe="0"
    :style="`height: ${windowHeight};`"
  >
    <van-swipe-item>
      <div class="page2-5">
        <img
          class="logo"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
        />
        <img
          class="main-student"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/uk-student1.png"
        />
        <div class="age-wrap">
          <img
            class="note1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
          />
          <img
            class="note2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
          />
          <img
            class="age-img"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/light-green-tips.png"
          />
          <span class="text">6岁+</span>
        </div>
        <div class="main-title">尤克里里+</div>
        <div class="sub-title">UKULELE+</div>
        <div class="common-video-button" @click="showVideo('uk')">
          <div class="border1"></div>
          <div class="border2"></div>
          <div class="border3"></div>
          <div class="content">
            <van-icon name="play" />
            <span class="text">查看视频</span>
          </div>
        </div>
        <div class="group-type">
          <div class="item">
            <span class="dot"></span>
            <span class="text"
              >上课形式:<span class="num">3-6人</span>集体班</span
            >
          </div>
        </div>
        <div class="main-desc">
          <div class="title">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-longer.png"
            />
            <span class="text">超会弹唱的尤克里里+课程</span>
          </div>
          <div class="desc">
            音乐窝教研团队专为6岁+尤克里里爱好者研发,<span class="green"
              >以“系统教、简单学、快乐弹”为主要特色</span
            >，是一套非常适合开设集体互动课程的教学体系，让学员在学习过程中,培养感受生活和音乐的能力
          </div>
        </div>
        <div class="course-wrap">
          <!-- <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-blue.png"
          /> -->
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程优势</span>
          </div>
          <div class="list">
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon12.png"
              />
              <div class="text">
                <div class="title">简单学</div>
                <div class="desc">
                  从孩子的视角教授复杂的乐理知识和演奏技巧,让孩子轻松理解和学习
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon9.png"
              />
              <div class="text">
                <div class="title">小身体</div>
                <div class="desc">
                  音乐窝定制的多彩轻萌Ukulele让小龄学员也不再怕学习乐器,爱上音乐从看到它的第一眼开始
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon10.png"
              />
              <div class="text">
                <div class="title">快乐弹</div>
                <div class="desc">
                  多样、适龄、好听的选曲,能让孩子体验不同音乐风格的同时享受练琴的快乐和成就感
                </div>
              </div>
            </div>
            <div class="item">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon11.png"
              />
              <div class="text">
                <div class="title">大智慧</div>
                <div class="desc">
                  每首乐曲融入乐理知识,并提供演奏示范视频和件奏，让练琴更高效
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-wrap">
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程收获</span>
          </div>
          <div class="list">
            <div class="item">
              <van-icon name="success" />
              <span class="text">学习基础乐理知识</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">掌握右手扫弦组合</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">培养视奏和视唱能力</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">提升音乐审美能力</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">达到国内6级水平</span>
            </div>
          </div>
          <img
            class="bottom-img1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/uk-student2.png"
          />
        </div>
        <div class="bottom-arrow-wrap">
          <img
            class="bottom-line-red1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red1.png"
          />
          <img
            class="bottom-line-red2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red3.png"
          />
          <div class="bottom-arrow-tips">
            <div class="red">滑动</div>
            <div>了解更多吉他教程</div>
          </div>
        </div>
      </div>
    </van-swipe-item>
    <van-swipe-item>
      <div class="page2-5 guitar">
        <img
          class="logo"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
        />
        <img
          class="main-student"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/guitar-student1.png"
        />
        <div class="age-wrap">
          <img
            class="age-img"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/light-green-tips.png"
          />
          <img
            class="note1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note2.png"
          />
          <img
            class="note2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
          />
          <span class="text">6岁+</span>
        </div>
        <div class="main-title">民谣吉他</div>
        <div class="sub-title">GUITAR</div>
        <div class="common-video-button" @click="showVideo('guitar')">
          <div class="border1"></div>
          <div class="border2"></div>
          <div class="border3"></div>
          <div class="content">
            <van-icon name="play" />
            <span class="text">查看视频</span>
          </div>
        </div>
        <div class="group-type">
          <div class="item">
            <span class="dot"></span>
            <span class="text">上课形式:<span class="num">1v1</span></span>
          </div>
          <div class="item">
            <span class="dot"></span>
            <span class="text"
              >上课形式:<span class="num">3-6人</span>集体班</span
            >
          </div>
        </div>
        <div class="main-desc">
          <div class="title">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-long.png"
            />
            <span class="text">玩吉他，竟如此有趣</span>
          </div>
          <div class="desc">
            课程以低门槛入门,学员从单音到和弦的方式理解每个音的意义,获得阶段性成长,<span
              class="green"
              >更以编配和创作为目标,让每个学员都有机会玩创音乐</span
            >
          </div>
        </div>
        <div class="course-wrap">
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-yellow1.png"
          />
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程优势</span>
          </div>
          <div class="list-type1">
            <div class="item">
              <div class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon13.png"
                />
                <span class="text">智能教辅工具</span>
              </div>
              <div class="desc">
                每首练习曲和乐曲配有视频演示和音频伴奏,课后练习不再枯燥
              </div>
            </div>
            <div class="item">
              <div class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon5.png"
                />
                <span class="text">全面性</span>
              </div>
              <div class="desc">
                由课程知识点延伸，从模仿到改编再到创作的全方位教学
              </div>
            </div>
            <div class="item">
              <div class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon12.png"
                />
                <span class="text">易上手</span>
              </div>
              <div class="desc">
                单音-音程-和弦，每个阶段都有成果明白每个音的意义
              </div>
            </div>
          </div>
        </div>
        <div class="result-wrap">
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程收获</span>
          </div>
          <div class="list">
            <div class="item">
              <van-icon name="success" />
              <span class="text">具备创编、弹唱·独奏能力</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">掌握乐理知识</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">感受不同演奏技巧</span>
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text">培养视奏、视唱能力</span>
            </div>
          </div>
          <img
            class="bottom-img1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/guitar-student2.png"
          />
          <img
            class="bottom-img2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/guitar-student3.png"
          />
        </div>
        <div class="bottom-arrow-wrap">
          <img
            class="bottom-line-red1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red1.png"
          />
          <img
            class="bottom-line-red2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red3.png"
          />
          <div class="bottom-arrow-tips">
            <div class="red">滑动</div>
            <div>了解更多吉他教程</div>
          </div>
        </div>
      </div>
    </van-swipe-item>
    <van-swipe-item>
      <div class="page2-5 e-guitar">
        <img
          class="logo"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/wow-color.png"
        />
        <img
          class="main-student"
          src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/eg-student1.png"
        />
        <div class="age-wrap">
          <img
            class="note1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note1.png"
          />
          <img
            class="note2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-note3.png"
          />
          <img
            class="age-img"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/light-green-tips.png"
          />
          <span class="text">6岁+</span>
        </div>
        <div class="main-title">电吉他</div>
        <div class="sub-title">ELECTRIC GUITAR</div>
        <div class="group-type">
          <div class="item">
            <span class="dot"></span>
            <span class="text">上课形式:<span class="num">1v1</span></span>
          </div>
          <div class="item">
            <span class="dot"></span>
            <span class="text"
              >上课形式:<span class="num">3-6人</span>集体班</span
            >
          </div>
        </div>
        <div class="main-desc">
          <div class="title">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-longer.png"
            />
            <span class="text">用电吉他打开音乐新视界</span>
          </div>
          <div class="desc">
            音乐窝创新研发的电吉他课程,打破国内外吉他教材的固有学习模式。<span
              class="green"
              >以零基础入门,让学员完成从学电吉他到玩音乐的转变</span
            >，让兴趣引导学员,稳扎稳打地学习并主动去探索电吉他世界的奥义
          </div>
        </div>
        <div class="course-wrap">
          <img
            class="line"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-yellow1.png"
          />
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程优势</span>
          </div>
          <div class="list-type1">
            <div class="item">
              <div class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon12.png"
                />
                <span class="text">真正0基础学习</span>
              </div>
              <div class="desc">
                打破传统木吉他到电吉他教学模式,从零开始学习电吉他
              </div>
            </div>
            <div class="item">
              <div class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon13.png"
                />
                <span class="text">强大的教辅工具</span>
              </div>
              <div class="desc">
                每首练习曲和乐曲在App均配有演示与件奏，课后随时随地配合练习,让练习更高效
              </div>
            </div>
            <div class="item">
              <div class="title">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/icon/icon5.png"
                />
                <span class="text">全面素质提升</span>
              </div>
              <div class="desc">
                由浅入深地学习基础乐理，演奏技巧,音乐风格。更有机会组成乐队表演展示
              </div>
            </div>
          </div>
        </div>
        <div class="result-wrap">
          <div class="tag">
            <img
              class="img"
              src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/green-tips-short.png"
            />
            <span class="text">课程收获</span>
          </div>
          <div class="list">
            <div class="item">
              <van-icon name="success" />
              <span class="text"
                >掌握C大调音阶&和弦，基础节奏型，基础演奏技巧&和弦转换</span
              >
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text"
                >掌握更复杂节奏型&调式音阶，更丰富的演奏技巧</span
              >
            </div>
            <div class="item">
              <van-icon name="success" />
              <span class="text"
                >解锁更多高难度乐曲与音乐演奏的情感处理达到国内电吉他二~八级水平</span
              >
            </div>
          </div>
          <img
            class="bottom-img1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/eg-student2.png"
          />
        </div>
        <div class="bottom-arrow-wrap">
          <img
            class="bottom-line-red1"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red1.png"
          />
          <img
            class="bottom-line-red2"
            src="https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/page2/line-red3.png"
          />
          <div class="bottom-arrow-tips">
            <div class="red">滑动</div>
            <div>了解更多吉他教程</div>
          </div>
        </div>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: "100vh",
    };
  },
  methods: {
    showVideo(type) {
      this.$emit("click-video", type);
    },
    swiperResize() {
      const isIos = !!navigator.userAgent.match(
        /\(i[^;]+;( U;)? CPU.+Mac OS X/
      ); //ios终端
      if (isIos) {
        this.windowHeight = window.innerHeight + "px";
      } else {
        this.windowHeight = "100vh";
      }
      this.$nextTick(() => {
        this.$refs["inner-swiper1"].resize();
      });
    },
  },
  mounted() {
    this.swiperResize();
    window.addEventListener("resize", this.swiperResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.swiperResize);
  },
};
</script>
<style scoped lang="scss">
@function perS($w) {
  @return ($w/375) * 100vw;
}
.inner-swiper {
  .van-swipe-item {
    height: 100%;
  }
}
.page2-5 {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100%;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/exhibition_2025/bg-light.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  &.guitar {
    .age-wrap {
      .note1 {
        width: perS(35);
        transform: rotate(-20deg);
        top: perS(80);
        left: perS(170);
      }
      .note2 {
        width: perS(32);
        transform: rotate(20deg);
        top: perS(125);
        left: perS(300);
      }
    }
    .main-student {
      width: perS(274);
      right: perS(-31);
      top: 14vh;
    }
    .main-desc {
      margin-top: perS(4);
      .title {
        .img {
          width: perS(131);
        }
      }
    }
    .course-wrap {
      .line {
        width: perS(61);
        right: perS(-25);
        top: perS(-32);
      }
      .list-type1 {
        display: flex;
        justify-content: space-between;
        .item {
          width: perS(87);
          height: perS(67);
          padding: perS(6) perS(8);
          border-radius: perS(12);
          background-color: #fff;
          box-shadow: 0 1px 2px #eee;
          .title {
            display: flex;
            align-items: center;
            margin-bottom: perS(6);
            .icon {
              width: perS(24);
              height: auto;
              margin-right: perS(4);
            }
            .text {
              font-size: perS(10);
              color: #000;
              font-weight: 900;
              line-height: perS(11);
              white-space: nowrap;
            }
          }
          .desc {
            font-size: perS(7);
            color: #000;
            font-weight: 400;
            line-height: perS(8);
          }
        }
      }
    }
    .result-wrap {
      .bottom-img1 {
        width: perS(114);
        top: perS(-8);
        right: perS(30);
      }
      .bottom-img2 {
        position: absolute;
        width: perS(137);
        height: auto;
        top: perS(25);
        right: perS(90);
      }
    }
  }
  &.e-guitar {
    .main-student {
      width: perS(375);
      right: perS(-100);
      top: 12vh;
    }
    .group-type {
      margin-top: perS(25);
    }
    .age-wrap {
      .note1 {
        width: perS(20);
        transform: rotate(0);
        top: perS(140);
        left: perS(110);
      }
      .note2 {
        width: perS(35);
        transform: rotate(25deg);
        top: perS(80);
        left: perS(280);
      }
    }
    .main-desc {
      margin-top: perS(18);
      .title {
        .img {
          width: perS(154);
        }
      }
      .desc {
        margin-top: perS(-5);
      }
    }
    .course-wrap {
      .line {
        width: perS(61);
        right: perS(140);
        top: perS(-180);
        transform: rotate(130deg);
        z-index: 100;
      }
      .list-type1 {
        display: flex;
        justify-content: space-between;
        .item {
          width: perS(87);
          height: perS(67);
          padding: perS(6) perS(8);
          border-radius: perS(12);
          background-color: #fff;
          box-shadow: 0 1px 2px #eee;
          .title {
            display: flex;
            align-items: center;
            margin-bottom: perS(6);
            .icon {
              width: perS(24);
              height: auto;
              margin-right: perS(4);
            }
            .text {
              font-size: perS(10);
              color: #000;
              font-weight: 900;
              line-height: perS(11);
              white-space: nowrap;
            }
          }
          .desc {
            font-size: perS(7);
            color: #000;
            font-weight: 400;
            line-height: perS(8);
          }
        }
      }
    }
    .result-wrap {
      .bottom-img1 {
        width: perS(114);
        top: perS(-8);
        right: perS(30);
      }
    }
  }
  .logo {
    width: perS(90);
    height: auto;
    position: absolute;
    top: 8vh;
    right: perS(28);
    z-index: 100;
  }
  .main-student {
    width: perS(268);
    height: auto;
    position: absolute;
    top: 3vh;
    right: perS(-30);
  }
  .age-wrap {
    position: relative;
    margin: 7vh 0 perS(10) perS(25);
    .note1 {
      width: perS(30);
      height: auto;
      position: absolute;
      top: perS(130);
      left: perS(300);
      z-index: 100;
      transform: rotate(35deg);
    }
    .note2 {
      width: perS(19);
      height: auto;
      position: absolute;
      top: perS(130);
      left: perS(140);
      z-index: 100;
    }
    .age-img {
      width: perS(62);
      height: auto;
    }
    .text {
      font-size: perS(18);
      line-height: perS(20);
      font-weight: 900;
      color: #fff;
      transform: rotate(-7deg);
      position: absolute;
      top: perS(6);
      left: perS(8);
    }
  }
  .main-title {
    position: relative;
    color: #46b13a;
    margin: 0 0 0 perS(25);
    font-size: perS(40);
    line-height: perS(40);
    font-weight: 900;
  }
  .sub-title {
    position: relative;
    color: #000;
    margin: 0 0 0 perS(25);
    font-size: perS(20);
    line-height: perS(20);
    font-weight: 900;
  }
  .group-type {
    margin: perS(8) 0 0 perS(25);
    position: relative;
    .item {
      .dot {
        display: inline-block;
        width: perS(5);
        height: perS(5);
        border-radius: 50%;
        background-color: #46b13a;
        margin-right: perS(4);
      }
      .text {
        color: #000;
        font-size: perS(9);
        line-height: perS(23);
        font-weight: 500;
        .num {
          font-size: perS(12);
          font-weight: 700;
        }
      }
    }
  }
  .main-desc {
    position: relative;
    margin: perS(30) perS(25) 0 perS(25);
    .title {
      position: relative;
      .img {
        width: perS(157);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-8deg);
        position: absolute;
        top: perS(12.5);
        left: perS(7);
      }
    }
    .desc {
      background-color: #fff;
      margin: perS(-11) 0 0 0;
      padding: perS(10) perS(12);
      border-radius: perS(14);
      font-size: perS(8);
      line-height: perS(13);
      font-weight: 500;
      color: #000;
      box-shadow: 0 1px 2px #eee;
      .green {
        color: #46b13a;
        font-weight: 700;
      }
    }
  }
  .course-wrap {
    position: relative;
    margin: perS(8) perS(25) 0 perS(25);
    .line {
      position: absolute;
      right: perS(-34);
      top: perS(18);
      width: perS(77);
      height: auto;
    }
    .tag {
      position: relative;
      margin-bottom: perS(-5);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      padding: perS(12);
      border-radius: perS(14);
      background-color: #fff;
      box-shadow: 0 1px 2px #eee;
      .item {
        display: inline-flex;
        vertical-align: top;
        align-items: start;
        width: 50%;
        margin-bottom: perS(10);
        &:last-child {
          margin-bottom: 0;
        }
        .icon {
          width: perS(23);
          height: auto;
          margin-right: perS(4);
        }
        .text {
          .title {
            font-size: perS(13);
            font-weight: 900;
            line-height: perS(11);
            color: #000;
          }
          .desc {
            width: perS(100);
            font-size: perS(7);
            font-weight: 400;
            line-height: perS(10);
            color: #000;
            margin-top: perS(6);
          }
        }
      }
    }
  }
  .result-wrap {
    margin: perS(10) 0 0 perS(25);
    position: relative;
    .tag {
      position: relative;
      margin-bottom: perS(0);
      .img {
        width: perS(70);
        height: auto;
      }
      .text {
        font-size: perS(12);
        line-height: perS(20);
        font-weight: 900;
        color: #fff;
        transform: rotate(-7deg);
        position: absolute;
        top: perS(6.5);
        left: perS(10);
      }
    }
    .list {
      width: perS(169);
      .item {
        display: flex;
        .van-icon {
          margin-right: perS(8);
        }
        .text {
          font-size: perS(8);
          line-height: perS(16);
          font-weight: 500;
          color: #000;
          .green {
            color: #46b13a;
          }
        }
      }
    }
    .bottom-img1 {
      position: absolute;
      width: perS(123);
      height: auto;
      right: perS(100);
      top: perS(0);
      z-index: 1;
    }
  }
  .bottom-arrow-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: perS(65);
    animation: bottomArrowSwing 1.2s linear infinite;
    z-index: 1000;
    .bottom-line-red1 {
      position: absolute;
      width: perS(75);
      height: auto;
      right: perS(0);
      top: perS(-50);
      z-index: 2;
    }
    .bottom-line-red2 {
      position: absolute;
      width: perS(112);
      height: auto;
      right: perS(95);
      top: perS(0);
      z-index: 2;
    }
    .bottom-arrow-tips {
      font-size: perS(9);
      font-weight: 500;
      line-height: perS(14);
      color: #000;
      position: absolute;
      right: perS(14);
      top: perS(0);
      .red {
        font-size: perS(12);
        color: #d8654a;
        line-height: perS(11);
      }
    }
  }
}
@keyframes bottomArrowSwing {
  0% {
    transform: translate3d(0, 0, 0);
  }
  50% {
    transform: translate3d(-2%, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@media screen and (max-height: 720px) {
  .page2-5 {
    .logo {
      top: 2vh;
    }
    .age-wrap {
      margin-top: 4vh;
    }
    .main-desc {
      margin-top: 0;
      .desc {
        padding: 1vh;
      }
    }
    .common-video-button {
      margin-top: 0;
    }
    .group-type {
      margin-top: 0;
    }
    .main-student {
      top: -3vh;
    }
    .bottom-arrow-wrap {
      bottom: 6vh;
    }
    .course-wrap {
      .list {
        padding: 1vh;
        .item {
          margin-bottom: 1vh;
        }
      }
    }
    &.guitar {
      .main-student {
        top: 12vh;
      }
    }
    &.e-guitar {
      .main-student {
        top: 8vh;
      }
    }
  }
}
/deep/.van-swipe__indicator--active {
  background-color: #45b23a !important;
}
.common-video-button {
  display: inline-block;
  position: relative;
  padding: 10px;
  margin: perS(10) 0 0 perS(25);
  .border1 {
    border: 1px solid #ea5d40;
    border-radius: 16px;
    animation: 0.8s ease-in-out 0.6s videoBorderButtonFade infinite;
    position: absolute;
    top: 3px;
    left: 3px;
    width: 95px;
    height: 39px;
    display: none;
  }
  .border2 {
    border: 0.8px solid #ea5d40;
    border-radius: 15px;
    animation: 1s ease-in-out 0.3s videoBorderButtonFade infinite;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 90px;
    height: 35px;
    display: none;
  }
  .border3 {
    border: 0.8px solid #ea5d40;
    border-radius: 14px;
    animation: 1s ease-in-out 0s videoBorderButtonFade infinite;
    position: absolute;
    top: 8px;
    left: 7px;
    width: 86px;
    height: 29px;
    display: none;
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ea5d40;
    border-radius: 15px;
    width: 82px;
    height: 26px;
    animation: 1.5s ease-in-out 0s videoBorderButtonScale infinite;
    .van-icon {
      font-size: 12px;
      margin-right: 4px;
      color: #fff;
    }
    .text {
      color: #fff;
      font-size: 12px;
      line-height: 12px;
      font-weight: 700;
    }
  }
}
@keyframes videoBorderButtonScale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes videoBorderButtonFade {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 0.6;
  }
}
</style>
